import TextEditor from '@/components/ui/text-editor';
import { LongTextBlock as ILongTextBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: ILongTextBlock;
}

export default function LongTextBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <TextEditor
        initialValue={payload?.value || ''}
        onChange={(newContent) => updatePayload({ value: newContent })}
      />
    </BaseInputBlock>
  );
}
